import {
  DataObjectId,
  Hub,
  repeatTemplatesContainerId,
  SandboxTree
} from 'yougile-model'
import {globals} from '../extensions/globals-base'
import {UserAccess} from '../extensions/user-access'
import {PermissionsChecker} from './permissions-checker'
import {Sync} from './sync'

export class RepeatClient {
  public static canEditTemplate(box: SandboxTree, tpl: Hub): boolean {
    const colId = tpl?.data?.repeatTemplate?.columnId
    const col = box.getHub(colId)
    const boardId = col?.location
    return RepeatClient.canEditRepeatTasks(box, boardId)
  }

  public static canEditRepeatTasks(
    box: SandboxTree,
    boardId: DataObjectId | undefined
  ): boolean {
    const proj = box.getProjectFor(boardId)
    if (!proj) {
      return false
    }
    const role = UserAccess.getRoleInProject(globals.currentUserId, proj)
    return (
      PermissionsChecker.isAdmin({userId: globals.currentUserId, box}) ||
      role === 'admin' ||
      role === 'worker'
    )
  }

  public static getAllTemplates(companyId: DataObjectId): Hub[] {
    const box = Sync.get({companyId})
    return box.getChildrenHubs(repeatTemplatesContainerId)
  }

  public static getBoardTemplates(board: Hub | undefined): Hub[] {
    if (!board) {
      return []
    }
    const all = RepeatClient.getAllTemplates(board.companyId)
    const box = Sync.get(board)
    return all.filter(h => {
      if (!h || h.deleted) {
        return false
      }
      const col = h.data.repeatTemplate?.columnId
      return col && (box.get(col) as Hub)?.location === board.id
    })
  }
}
